module.exports = __webpack_public_path__ + "static/media/opensans-extrabold.1e7796f8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-extrabold.woff
// module id = 296
// module chunks = 0